import React, { CSSProperties, useContext, useState } from "react";
import Button from "common/Buttons/Button";
import TextAreaWithTitle from "common/Inputs/TextAreaWithTitle";
import { DisabledOverlay } from "common/styles";
import { useTheme } from "styled-components";
import { hexToRGB } from "@shared/utils/misc";
import FreeTextModal from "features/tradingTerminal/FreeText/FreeTextModal";
import { TradingTerminalContext } from "@shared/features/tradingTerminal/TradingTerminal.context";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface FreeTextModalAndTriggerProps {
  style?: CSSProperties;
}

const FreeTextModalAndTrigger = ({ style }: FreeTextModalAndTriggerProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADING_TERMINAL);
  const appTheme = useTheme();
  const { rawFreeText } = useContext(TradingTerminalContext)!;
  const [freeTextModalOpen, setFreeTextModalOpen] = useState(false);

  return (
    <>
      <DisabledOverlay
        $disabled={!rawFreeText}
        onClick={() => setFreeTextModalOpen(true)}
      >
        <TextAreaWithTitle
          title={t("labels.trade_text")}
          placeholder={t("placeholders.free_text")}
          allowClear={false}
          autoSize={{ minRows: 3, maxRows: 3 }}
          value={(rawFreeText || "").replace(/(\r\n|\n|\r)/gm, " ")}
          wrapperStyle={{
            width: "100%",
            height: "100%",
            padding: "6px 0",
            boxShadow: appTheme.isDarkMode ? "none" : undefined,
            ...style,
          }}
          usePointerCursor={true}
        />
        <Button type="primary">{t("buttons.free_text")}</Button>
      </DisabledOverlay>
      <FreeTextModal
        visible={freeTextModalOpen}
        closeModal={() => setFreeTextModalOpen(false)}
      />
    </>
  );
};

export default FreeTextModalAndTrigger;
